<ion-app>
  <div class="app-container d-flex flex-column">
    <ion-router-outlet></ion-router-outlet>
  </div>
</ion-app>
